import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconUsbC: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconUsbC"><Path d="M5.5 12H18.5M6 17.5H18C21.0376 17.5 23.5 15.0376 23.5 12C23.5 8.96243 21.0376 6.5 18 6.5H6C2.96243 6.5 0.5 8.96243 0.5 12C0.5 15.0376 2.96243 17.5 6 17.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconUsbC;
